import styled from 'styled-components'

import { useTranslation } from '../../../lang'

const Wrapper = styled.div`
  ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
  }

  .no-data {
    text-align: center;
    margin-bottom: 40px;
  }
`

type Props = {
  length?: number
  tag?: string
  children: React.ReactNode
}

const EventList: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <ul>{props.children}</ul>
      {props.length !== 0 ? '' : <div className="no-data">{t('pages.eventList.contents.empty')}</div>}
    </Wrapper>
  )
}

export default EventList
